import { AbstractControl, AsyncValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { CredentialsService } from '../../core/misc';
import { UserInputCheck } from '../../core/model';

export abstract class PasswordValidator {
  public static isPasswordValid(
    credentialsService: CredentialsService,
    usernameFieldName: string,
    passwordFieldName: string
  ): AsyncValidatorFn {
    return (group: AbstractControl): Observable<ValidationErrors | null> => {
      if (!this.isFormGroup(group)) {
        throw new Error('Password validator must attach to form group');
      }

      const usernameControl = group.get(usernameFieldName);
      const passwordControl = group.get(passwordFieldName);

      if (!this.isValid(passwordControl)) {
        return of(null);
      }

      return timer(500) // no spamming allowed
        .pipe(
          switchMap(() => credentialsService.validatePassword(passwordControl.value, usernameControl.value)),
          map((check: UserInputCheck) => {
            return check.valid ? null : { [passwordFieldName]: check };
          }),
          take(1)
        );
    };
  }

  private static isFormGroup(control: AbstractControl): control is UntypedFormGroup {
    return Boolean((control as UntypedFormGroup).controls);
  }

  private static isValid(control: AbstractControl): boolean {
    return control && !!control.value;
  }
}
